import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { EmptySelectionTaxonomy } from '../../../taxonomy.constants';
import { TaxonomyService } from '../../../../../services/taxonomy.service';

@Component({
  selector: 'intent-form',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './intent-form.component.html',
  styleUrl: './intent-form.component.scss',
})
export class IntentFormComponent {
  constructor(
    private formBuilder: FormBuilder,
    public taxonomyService: TaxonomyService
  ) {
    this.intentForm = this.formBuilder.group({
      label: ['', Validators.required],
      description: [''],
    });
  }

  @Input() selectedTaxonomyItem: any = { ...EmptySelectionTaxonomy };
  @Input() editId: number | undefined;
  @Output() onIntentFormClose = new EventEmitter<void>();
  @Output() onIntentFormComplete = new EventEmitter<void>();

  intentForm: FormGroup;

  ngOnInit() {
    if (this.editId != undefined && this.taxonomyService.selectedEnitity?.LinkedEntities) {
      const intent = this.taxonomyService.selectedEnitity?.LinkedEntities[this.editId];
      this.intentForm.patchValue({
        label: intent.label,
        description: intent.description,
      });
    }
  }

  handleCancelIntent() {
    this.onIntentFormClose.emit();
  }

  handleAddIntent() {
    if (this.editId != undefined && this.taxonomyService.selectedEnitity?.LinkedEntities) {
      this.taxonomyService.selectedEnitity.LinkedEntities[this.editId] = {
        ...this.intentForm.value,
      };
    } else {
      const previousIntents = this.taxonomyService.selectedEnitity?.LinkedEntities ?? [];
      const tempIntents = [...previousIntents, { ...this.intentForm.value }];

      this.taxonomyService.selectedEnitity.LinkedEntities = tempIntents;
    }
    this.onIntentFormComplete.emit();
  }
}
